package com.macrofocus.eflux.data.quest

import com.macrofocus.eflux.LagUnit
import com.macrofocus.eflux.network.logical.LogicalBranchId
import com.macrofocus.eflux.network.physical.BusId
import org.molap.dataframe.DataFrame
import org.molap.questdb.DateTimeHandling
import org.molap.questdb.loadJson
import org.molap.questdb.loadQuestDB

actual suspend fun loadITCM(): DataFrame<Int, String, Any?> {
    return loadJson("/itcm.json")
}

actual suspend fun loadCoordinates(): DataFrame<Int, String, Any?> {
    return loadQuestDB("/db/coordinates")
}

actual suspend fun loadZones(date: String): DataFrame<Int, String, Any?> {
    return loadQuestDB("/db/zones/$date")
}

actual suspend fun loadBuses(date: String): DataFrame<Int, String, Any?> {
    return loadQuestDB("/db/buses/$date")
}

actual suspend fun loadLogicalBuses(date: String): DataFrame<Int, String, Any?> {
    return loadQuestDB("/db/logicalBuses/$date")
}

actual suspend fun loadLogicalBranches(date: String): DataFrame<Int, String, Any?> {
    return loadQuestDB("/db/logicalBranches/$date")
}

actual suspend fun loadBus(
    bus: BusId,
    date: String,
    lagUnit: LagUnit
): DataFrame<Int, String, Any?> {
    val params = lagUnit.params
    return loadQuestDB("/db/bus/$bus/$date?$params", dateTimeHandling = DateTimeHandling.Long)
}

actual suspend fun loadLogicalBranch(
    branch: LogicalBranchId,
    date: String,
    lagUnit: LagUnit
): DataFrame<Int, String, Any?> {
    val params = lagUnit.params
    return loadQuestDB("/db/logicalBranch/$branch/$date?$params", dateTimeHandling = DateTimeHandling.Long)
}